export const PROMPT_JSON = [
  {
    id: 1,
    title: '写作助手',
    prompts: [
      {
        id: 1,
        title: '撰写标题',
        content:
          '写出<span style="background:#CCE6FF;border-radius: 4px;padding: 0 5px;font-weight: 600;">n</span>个有关<span style="background:#CCE6FF;border-radius: 4px;padding: 0 5px;font-weight: 600;">主题</span>的<span style="background:#CCE6FF;border-radius: 4px;padding: 0 5px;font-weight: 600;">社群平台</span>风格标题，要遵守以下规则<span style="background:#CCE6FF;border-radius: 4px;padding: 0 5px;font-weight: 600;">规则1</span>、<span style="background:#CCE6FF;border-radius: 4px;padding: 0 5px;font-weight: 600;">规则2</span>、<span style="background:#CCE6FF;border-radius: 4px;padding: 0 5px;font-weight: 600;">其他规则</span>。',
        tip: '写出 5 个有关日本迪士尼旅游心得的Ins风标题，要遵守以下规则：标题不超过 20 字、标题要加上适当表情符号。',
      },
      {
        id: 2,
        title: '文章撰写',
        content: '针对<span style="background:#CCE6FF;border-radius: 4px;padding: 0 5px;font-weight: 600;">主题</span>这个主题生成一篇文章',
        tip: '针对使用 ChatGPT 小诀窍这个主题生成一篇文章',
      },
      {
        id: 3,
        title: '改正文法错误',
        content:
          '请扮演编辑人员，提供反馈改善以下文章的文法。识别和更正任何错误，同时提出改善写作风格的建议。请将建议和更正提供清晰的解释。文章为<span style="background:#CCE6FF;border-radius: 4px;padding: 0 5px;font-weight: 600;">附上文章</span>。',
        tip: '请扮演编辑人员，提供反馈改善以下文章。识别文章错误，改善写作风格及建议。文章为[附上文章]。',
      },
      {
        id: 4,
        title: '撰写文章大纲',
        content: '提供<span style="background:#CCE6FF;border-radius: 4px;padding: 0 5px;font-weight: 600;">某主题</span>主题的文章大纲 。',
        tip: '提供美国留学主题的文章大纲',
      },
      {
        id: 5,
        title: '产品文案',
        content: '将以下产品关键字生成<span style="background:#CCE6FF;border-radius: 4px;padding: 0 5px;font-weight: 600;">n</span>句的产品文案。产品关键字<span style="background:#CCE6FF;border-radius: 4px;padding: 0 5px;font-weight: 600;">附上关键字...</span>',
        tip: '将以下产品关键字生成 10 句的产品文案。产品关键字：球鞋、春季最新款、多种颜色、适合慢跑',
      },
      {
        id: 6,
        title: '报告总结',
        content:
          '你是<span style="background:#CCE6FF;border-radius: 4px;padding: 0 5px;font-weight: 600;">某个主题</span>的专家，请总结以下内容，并针对以下内容提出未来能进一步研究的方向<span style="background:#CCE6FF;border-radius: 4px;padding: 0 5px;font-weight: 600;">附上内容</span>',
        tip: '你是金融科技专家，请总结以下内容，并针对以下内容提出未来能进一步研究的方向 [附上内容]',
      },
    ],
  },
  {
    id: 2,
    title: '资料整理',
    prompts: [
      {
        id: 1,
        title: '搜集资料',
        content: '给我<span style="background:#CCE6FF;border-radius: 4px;padding: 0 5px;font-weight: 600;">n</span>篇，有关<span style="background:#CCE6FF;border-radius: 4px;padding: 0 5px;font-weight: 600;">领域</span>的文章。',
        tip: '给我 5 篇，有关 SEO 的文章。',
      },
      {
        id: 2,
        title: '摘录某领域重点',
        content: '用列点的方式总结出<span style="background:#CCE6FF;border-radius: 4px;padding: 0 5px;font-weight: 600;">n</span>个<span style="background:#CCE6FF;border-radius: 4px;padding: 0 5px;font-weight: 600;">领域</span>知识重点',
        tip: '用列点方式总结出10个量子力学知识重点。',
      },
      {
        id: 3,
        title: '内容总结',
        content: '用列点的方式总结出这篇文章的<span style="background:#CCE6FF;border-radius: 4px;padding: 0 5px;font-weight: 600;">n</span>个重点：<span style="background:#CCE6FF;border-radius: 4px;padding: 0 5px;font-weight: 600;">附上文章内容</span>。',
        tip: '用列点的方式总结出这篇文章的 5 个重点：[附上文章内容/附上文章网址]。',
      },
    ],
  },
  {
    id: 3,
    title: '知识学习',
    prompts: [
      {
        id: 1,
        title: '概念解说',
        content: '详细的说明<span style="background:#CCE6FF;border-radius: 4px;padding: 0 5px;font-weight: 600;">填入想了解的知识</span>',
        tip: '详细的说明如何制造一台电脑',
      },
      {
        id: 2,
        title: '简易教学',
        content: '你扮演<span style="background:#CCE6FF;border-radius: 4px;padding: 0 5px;font-weight: 600;">科目老师</span>的角色， 我需要理解<span style="background:#CCE6FF;border-radius: 4px;padding: 0 5px;font-weight: 600;">理论</span>。 请用<span style="background:#CCE6FF;border-radius: 4px;padding: 0 5px;font-weight: 600;">方式</span>方式描述。',
        tip: '你扮演数学老师的角色， 我需要理解一元二次方程式。 请用浅显易懂方式描述。',
      },
      {
        id: 3,
        title: '解释一个知识的背后原理',
        content:
          '以一位<span style="background:#CCE6FF;border-radius: 4px;padding: 0 5px;font-weight: 600;">领域</span>教育家的身份，说明<span style="background:#CCE6FF;border-radius: 4px;padding: 0 5px;font-weight: 600;">概念</span>是什么。同时提供<span style="background:#CCE6FF;border-radius: 4px;padding: 0 5px;font-weight: 600;">n</span>个例子，来解释<span style="background:#CCE6FF;border-radius: 4px;padding: 0 5px;font-weight: 600;">概念</span>背后的原理。',
        tip: '用列点的方式总结出这篇文章的 5 个重点：[附上文章内容。]',
      },
      {
        id: 4,
        title: '提供学习方法',
        content:
          '现在你是一位<span style="background:#CCE6FF;border-radius: 4px;padding: 0 5px;font-weight: 600;">科目</span>教师。提供学习<span style="background:#CCE6FF;border-radius: 4px;padding: 0 5px;font-weight: 600;">知识</span>的技巧和诀窍。包括<span style="background:#CCE6FF;border-radius: 4px;padding: 0 5px;font-weight: 600;">具体内容</span>的学习方法。',
        tip: '现在你是一位英语教师。提供学习英语的技巧和诀窍。包括提高词汇、语法和发音的学习方法。',
      },
    ],
  },
  {
    id: 4,
    title: '工作生产力',
    prompts: [
      {
        id: 1,
        title: '回复 Email',
        content:
          '你是一名<span style="background:#CCE6FF;border-radius: 4px;padding: 0 5px;font-weight: 600;">职业</span>，我会给你一封电子邮件，你要回复这封电子邮件。电子邮件：<span style="background:#CCE6FF;border-radius: 4px;padding: 0 5px;font-weight: 600;">附上内容</span>',
        tip: '你是一名产品经理，我会给你一封电子邮件，你要回复这封电子邮件。电子邮件：[附上内容]',
      },
      {
        id: 2,
        title: '综合情境',
        content: '你现在是一名<span style="background:#CCE6FF;border-radius: 4px;padding: 0 5px;font-weight: 600;">角色</span>，你要针对我提出的问题提供建议。我的问题是：<span style="background:#CCE6FF;border-radius: 4px;padding: 0 5px;font-weight: 600;">附上问题。</span>',
        tip: '你现在是一名生涯教练，你要针对我提出的问题提供建议。我的问题是：我是否要出国念书？',
      },
    ],
  },
  {
    id: 5,
    title: '日常生活',
    prompts: [
      {
        id: 1,
        title: '提供点子',
        content: '提供<span style="background:#CCE6FF;border-radius: 4px;padding: 0 5px;font-weight: 600;">n</span>个<span style="background:#CCE6FF;border-radius: 4px;padding: 0 5px;font-weight: 600;">想法</span>的点子',
        tip: '提供 5 个情人节的点子',
      },
      {
        id: 2,
        title: '食谱生成',
        content: '提供给我一个食谱，食材包含<span style="background:#CCE6FF;border-radius: 4px;padding: 0 5px;font-weight: 600;">食材 1</span>、<span style="background:#CCE6FF;border-radius: 4px;padding: 0 5px;font-weight: 600;">食材 2</span>、<span style="background:#CCE6FF;border-radius: 4px;padding: 0 5px;font-weight: 600;">食材 ...</span>。',
        tip: '提供给我一个食谱，食材包含鸡腿肉、鸡蛋、起司。',
      },
      {
        id: 3,
        title: '旅游计划',
        content:
          '生成一份<span style="background:#CCE6FF;border-radius: 4px;padding: 0 5px;font-weight: 600;">n</span>天的<span style="background:#CCE6FF;border-radius: 4px;padding: 0 5px;font-weight: 600;">地点</span>旅游计划，交通工具是<span style="background:#CCE6FF;border-radius: 4px;padding: 0 5px;font-weight: 600;">交通工具...</span>。要遵守以下规则：<span style="background:#CCE6FF;border-radius: 4px;padding: 0 5px;font-weight: 600;">填入规则</span>',
        tip: '生成一份 5 天的东京旅游计划，交通工具是地铁和火车。要遵守以下规则：1. 地点要包含东京铁塔、富士山、迪士尼乐园 2. 需要包含交通如何乘坐 3. 一天不超过 3 个地点。',
      },
    ],
  },
];
